var map = {
	"./blue/five/דובדבן.mp3": "98ec",
	"./blue/five/המבורגר.mp3": "2231",
	"./blue/five/חיפושית.mp3": "a0e4",
	"./blue/five/חנוכה.mp3": "a4bf",
	"./blue/five/סוכריה.mp3": "481d",
	"./blue/five/עוגיות.mp3": "e343",
	"./blue/five/פתוח.mp3": "932b",
	"./blue/five/תפוח.mp3": "7ce4",
	"./blue/four/בובה.mp3": "6b25",
	"./blue/four/דובי.mp3": "148e",
	"./blue/four/חולצה.mp3": "e95d",
	"./blue/four/חתול.mp3": "eaea",
	"./blue/four/לוח.mp3": "e259",
	"./blue/four/סוכר.mp3": "3349",
	"./blue/four/סולם.mp3": "a4e2",
	"./blue/four/ציור.mp3": "f702",
	"./blue/four/רוח.mp3": "1ee7",
	"./blue/four/תוכי.mp3": "20f8",
	"./blue/six/1.mp3": "3f98",
	"./blue/six/10.mp3": "ea31",
	"./blue/six/2.mp3": "4060",
	"./blue/six/3.mp3": "5b0f",
	"./blue/six/4.mp3": "2c65",
	"./blue/six/5.mp3": "fa01",
	"./blue/six/6.mp3": "7907",
	"./blue/six/7.mp3": "3264",
	"./blue/six/8.mp3": "d822",
	"./blue/six/9.mp3": "c9f5",
	"./blue/three/בול.mp3": "8018",
	"./blue/three/הוא.mp3": "62e8",
	"./blue/three/חוט.mp3": "8487",
	"./blue/three/חום.mp3": "2936",
	"./blue/three/לול.mp3": "db90",
	"./blue/three/סוס.mp3": "3abf",
	"./blue/three/תות.mp3": "bda8",
	"./blue/two/א.mp3": "a7f5",
	"./blue/two/ג.mp3": "c3d0",
	"./blue/two/י.mp3": "e947",
	"./blue/two/ל.mp3": "49b6",
	"./blue/two/ס.mp3": "5783",
	"./blue/two/ע.mp3": "4741",
	"./blue/two/פ.mp3": "b33b",
	"./blue/two/צ.mp3": "a0d8",
	"./blue/two/ר.mp3": "483c",
	"./blue/two/ת.mp3": "da45",
	"./green/five/אפרסק.mp3": "9b96",
	"./green/five/ארנבת.mp3": "0567",
	"./green/five/חברים.mp3": "1da4",
	"./green/five/טלויזיה.mp3": "1176",
	"./green/five/ישראל.mp3": "bfa0",
	"./green/five/נדנדה.mp3": "2ff3",
	"./green/five/נחליאלי.mp3": "aa4e",
	"./green/five/שוטרת.mp3": "88eb",
	"./green/five/שמח.mp3": "fbc1",
	"./green/five/שרשרת.mp3": "80ba",
	"./green/four/אריה.mp3": "8788",
	"./green/four/זקן.mp3": "bb30",
	"./green/four/חורף.mp3": "3857",
	"./green/four/כסא.mp3": "7b03",
	"./green/four/מחשב.mp3": "cdea",
	"./green/four/משמש.mp3": "2b40",
	"./green/four/נמר.mp3": "c4c6",
	"./green/four/פלפל.mp3": "87ab",
	"./green/four/פרח.mp3": "1db7",
	"./green/six/1.mp3": "9592",
	"./green/six/2.mp3": "557a",
	"./green/six/3.mp3": "5a08",
	"./green/six/4.mp3": "649d",
	"./green/six/5.mp3": "44a30",
	"./green/six/6.mp3": "c324",
	"./green/six/7.mp3": "85de",
	"./green/six/8.mp3": "49bb",
	"./green/six/9.mp3": "10a1",
	"./green/three/אש.mp3": "4ef7",
	"./green/three/בן.mp3": "8764",
	"./green/three/הן.mp3": "8cec",
	"./green/three/יש.mp3": "6ca0",
	"./green/three/לב.mp3": "b230",
	"./green/three/נר.mp3": "79d6",
	"./green/three/עז.mp3": "aa3d",
	"./green/three/עט.mp3": "454c",
	"./green/three/פה.mp3": "54f8",
	"./green/three/קן.mp3": "67a5",
	"./green/two/ב.mp3": "ec54",
	"./green/two/ו.mp3": "87075",
	"./green/two/ז.mp3": "3ee7",
	"./green/two/ח.mp3": "c2b5",
	"./green/two/ט.mp3": "ea01",
	"./green/two/י.mp3": "7a7f",
	"./green/two/מ.mp3": "4456",
	"./green/two/ס.mp3": "d07d",
	"./green/two/ק.mp3": "1c5a",
	"./green/two/ר.mp3": "b951",
	"./green/two/ש_שווא.mp3": "459c",
	"./orange/five/אבוקדו.mp3": "4b84",
	"./orange/five/אופנוע.mp3": "c73c3",
	"./orange/five/אופנים.mp3": "4bb1",
	"./orange/five/חגורה.mp3": "8817",
	"./orange/five/חצוצרה.mp3": "9c4e",
	"./orange/five/טרקטור.mp3": "344e",
	"./orange/five/מתנות.mp3": "86f1",
	"./orange/five/פעמון.mp3": "8368",
	"./orange/five/שופר.mp3": "4300",
	"./orange/five/תולעת.mp3": "1c66",
	"./orange/four/בלון.mp3": "f330",
	"./orange/four/גדול.mp3": "360b",
	"./orange/four/חיות.mp3": "03a3",
	"./orange/four/חלום.mp3": "1a4e",
	"./orange/four/חלון.mp3": "c868",
	"./orange/four/חמור.mp3": "795d",
	"./orange/four/כובע.mp3": "9e6e",
	"./orange/four/כוכב.mp3": "85f5",
	"./orange/four/כפתור.mp3": "ef81",
	"./orange/four/כתום.mp3": "3626",
	"./orange/six/1.mp3": "96e9",
	"./orange/six/2.mp3": "f6eb",
	"./orange/six/3.mp3": "5690",
	"./orange/six/4.mp3": "4f80",
	"./orange/six/5.mp3": "cbbb",
	"./orange/six/6.mp3": "83e5",
	"./orange/three/אור.mp3": "bc93",
	"./orange/three/דוב.mp3": "a0a2",
	"./orange/three/חול.mp3": "6991",
	"./orange/three/חום.mp3": "2789",
	"./orange/three/חוף.mp3": "95a2",
	"./orange/three/יום.mp3": "69099",
	"./orange/three/כוס.mp3": "2ee4",
	"./orange/three/קוף.mp3": "71ff",
	"./orange/three/שור.mp3": "60c8",
	"./orange/three/תוף.mp3": "aa17",
	"./orange/two/ב.mp3": "2086",
	"./orange/two/ד.mp3": "ed37",
	"./orange/two/ה.mp3": "e435",
	"./orange/two/ח.mp3": "c437",
	"./orange/two/כו.mp3": "8a9d",
	"./orange/two/נ.mp3": "cba5",
	"./orange/two/ס.mp3": "64ce",
	"./orange/two/פ.mp3": "bb1e",
	"./orange/two/ק.mp3": "7b30",
	"./orange/two/ש.mp3": "c9d0",
	"./orange/two/ת.mp3": "8c8b",
	"./white/five/אזעקה.mp3": "827b",
	"./white/five/אמבטיה.mp3": "1443",
	"./white/five/אשפה.mp3": "7c9e",
	"./white/five/בננה.mp3": "d018",
	"./white/five/ברווז.mp3": "d67e",
	"./white/five/גלגל.mp3": "c318",
	"./white/five/הפסקה.mp3": "618d",
	"./white/five/הפתעה.mp3": "339b",
	"./white/five/הצגה.mp3": "fc2c",
	"./white/five/טבעת.mp3": "585e",
	"./white/five/מחבת.mp3": "2ab9",
	"./white/five/ממתק.mp3": "c0bc",
	"./white/five/מעטפה.mp3": "4bd2",
	"./white/five/מתנה.mp3": "1f71",
	"./white/five/סבתא.mp3": "c4d6",
	"./white/five/ספסל.mp3": "8f28",
	"./white/five/עגלה.mp3": "fc15",
	"./white/five/עכבר.mp3": "80e3",
	"./white/five/פרפר.mp3": "7388",
	"./white/five/צלחת.mp3": "2320",
	"./white/four/אבא.mp3": "46f1",
	"./white/four/אבד.mp3": "c330",
	"./white/four/אגס.mp3": "645a",
	"./white/four/אכל.mp3": "beaa",
	"./white/four/אמר.mp3": "97e6",
	"./white/four/בכה.mp3": "bedf",
	"./white/four/בנה.mp3": "5d49",
	"./white/four/ברח.mp3": "edb4",
	"./white/four/גנן.mp3": "38da",
	"./white/four/דאג.mp3": "2390",
	"./white/four/הלך.mp3": "4f83",
	"./white/four/חסה.mp3": "258c",
	"./white/four/חפרה.mp3": "d44c",
	"./white/four/טבח.mp3": "1aa3",
	"./white/four/ילדה.mp3": "87a4",
	"./white/four/ישב.mp3": "1a83",
	"./white/four/כתבה.mp3": "ddd3",
	"./white/four/לילה.mp3": "08b1",
	"./white/four/נחש.mp3": "c410",
	"./white/four/סבא.mp3": "62f7",
	"./white/four/ספר.mp3": "da36",
	"./white/four/סרטן.mp3": "ce38",
	"./white/four/ענן.mp3": "7a4f",
	"./white/four/עקרב.mp3": "42a3",
	"./white/four/פרפר.mp3": "ba56",
	"./white/four/קטן.mp3": "83604",
	"./white/four/קלמר.mp3": "e5bf",
	"./white/four/שתה.mp3": "6ee1",
	"./white/six/10.mp3": "a931",
	"./white/six/11.mp3": "ea52",
	"./white/six/12.mp3": "5911",
	"./white/six/4.mp3": "1014",
	"./white/six/5.mp3": "dbd1",
	"./white/six/6.mp3": "6da7",
	"./white/six/7.mp3": "a67d",
	"./white/six/8.mp3": "c36b",
	"./white/six/9.mp3": "c655",
	"./white/six/aba_daag.mp3": "f473",
	"./white/six/aba_darach.mp3": "26a7",
	"./white/six/saba.mp3": "a41f",
	"./white/three/אב.mp3": "49e2",
	"./white/three/אח.mp3": "8101",
	"./white/three/אף.mp3": "bb12",
	"./white/three/בת.mp3": "905e",
	"./white/three/גל.mp3": "27ac",
	"./white/three/גן.mp3": "7cdc",
	"./white/three/דג.mp3": "49de",
	"./white/three/הר.mp3": "b52b",
	"./white/three/חם.mp3": "6888",
	"./white/three/טס.mp3": "6c96",
	"./white/three/יד.mp3": "8900",
	"./white/three/ים.mp3": "1675",
	"./white/three/כף.mp3": "467b",
	"./white/three/סל.mp3": "804e",
	"./white/three/פח.mp3": "9ff9",
	"./white/three/צב.mp3": "e573",
	"./white/three/קו.mp3": "f0e4",
	"./white/three/קר.mp3": "826e",
	"./white/three/שי.mp3": "8bd1",
	"./white/three/שר.mp3": "e668",
	"./white/two/ב.mp3": "6862",
	"./white/two/ג.mp3": "165e",
	"./white/two/ח.mp3": "7781",
	"./white/two/ל.mp3": "5f3d",
	"./white/two/מ.mp3": "158e",
	"./white/two/פ.mp3": "fa5e",
	"./white/two/פה.mp3": "1f7b",
	"./white/two/ק.mp3": "c683",
	"./white/two/קה.mp3": "ea9b",
	"./white/two/ר.mp3": "4b3a",
	"./white/two/ש.mp3": "1549",
	"./yellow/five/אבטיח.mp3": "4803",
	"./yellow/five/חללית.mp3": "26da",
	"./yellow/five/לחמנייה.mp3": "e683",
	"./yellow/five/מגפיים.mp3": "1b68",
	"./yellow/five/מספריים.mp3": "88bd",
	"./yellow/five/משאית.mp3": "eff9",
	"./yellow/five/משחקים.mp3": "e4f7",
	"./yellow/five/משקפיים.mp3": "bd93",
	"./yellow/five/נעליים.mp3": "a2c4",
	"./yellow/five/עגבנייה.mp3": "9475",
	"./yellow/four/אמא.mp3": "bf4e",
	"./yellow/four/בית.mp3": "ac0a",
	"./yellow/four/כיתה.mp3": "6e1f",
	"./yellow/four/מטבח.mp3": "0ea2",
	"./yellow/four/מיטה.mp3": "603c",
	"./yellow/four/מים.mp3": "1bf5",
	"./yellow/four/סירה.mp3": "6d10",
	"./yellow/four/פטריה.mp3": "2d2c",
	"./yellow/four/קיץ.mp3": "cf6d",
	"./yellow/four/תלמיד.mp3": "3e5d",
	"./yellow/six/1.mp3": "237d",
	"./yellow/six/2.mp3": "ddc8",
	"./yellow/six/3.mp3": "b502",
	"./yellow/six/4.mp3": "a954",
	"./yellow/six/5.mp3": "8c43",
	"./yellow/three/ביס.mp3": "3207",
	"./yellow/three/טיל.mp3": "8130",
	"./yellow/three/כיס.mp3": "3d7d",
	"./yellow/three/מיץ.mp3": "1c39",
	"./yellow/three/סיר.mp3": "3025",
	"./yellow/three/עיר.mp3": "c8ab",
	"./yellow/three/פיל.mp3": "aae5",
	"./yellow/three/קיר.mp3": "0979",
	"./yellow/three/שיר.mp3": "a3ad",
	"./yellow/three/תיק.mp3": "28b0",
	"./yellow/two/א.mp3": "ca56",
	"./yellow/two/ה.mp3": "870a",
	"./yellow/two/ו.mp3": "d403",
	"./yellow/two/ז.mp3": "8327",
	"./yellow/two/ט.mp3": "fac6",
	"./yellow/two/נ.mp3": "8e30",
	"./yellow/two/ס.mp3": "447e",
	"./yellow/two/ע.mp3": "11d8",
	"./yellow/two/צ.mp3": "58e0",
	"./yellow/two/ש.mp3": "e7b2",
	"./yellow/two/ת.mp3": "d5e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2651";